import { JSX } from 'react'

import { Outlet } from 'react-router-dom'
import { useWebsocketSubscriptionLayout } from './use-websocket-subscription-layout'

const WebsocketSubscriptionLayout = (): JSX.Element => {
  useWebsocketSubscriptionLayout()

  return <Outlet />
}

export default WebsocketSubscriptionLayout
